import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Observable } from "rxjs";
import { VesignDataService } from "./vesign-data.service";
import { take, exhaustMap } from "rxjs/operators";


@Injectable()

export class AuthInterceport implements HttpInterceptor {
    constructor(private authService: VesignDataService<null>) {
    }
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let tokeniedReq = req.clone({ setHeaders: { Authorization: "Bearer " + this.authService.AuthToken } });
        return next.handle(tokeniedReq);
    }

}